import React from 'react'
import { Paragraph } from '@fs/zion-ui'
import { Trans } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { baseUrl } from '@fs/zion-config'

export default function UpdateMemoriesView() {
  return (
    <div>
      <Paragraph size="sm">
        <Trans
          components={[<Link key="toMemoriesGallery" to={`${baseUrl}/memories/gallery`} target="_blank" />]}
          defaults="Would you like to save this story as a new memory or overwrite the existing memory in your <0>memories gallery</0>?"
          i18nKey="UpdateMemoriesView.conformationText.description"
        />
      </Paragraph>
    </div>
  )
}
